export function formatAmount(value: string) {
    return value.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function removeCommas(value: string) {
    return value.replace(/,/g, '');
}
